/*! Sandwich — Cart Toast controller (5s auto, replace-on-spam, one-line fit) */
(() => {
  const el = (() => {
    let n = document.getElementById('toast');
    if (!n) {
      n = document.createElement('div');
      n.id = 'toast';
      n.className = 'cart-toast';
      n.innerHTML = `
        <span class="cart-toast__icon" aria-hidden="true">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
            <path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </span>
        <span class="cart-toast__text">Product added to cart</span>
        <button class="cart-toast__close" type="button" aria-label="Close">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
          </svg>
        </button>`;
      document.body.appendChild(n);
    }
    return n;
  })();

  const text = el.querySelector('.cart-toast__text');
  const btnClose = el.querySelector('.cart-toast__close');
  let timer = null;

  /* === One-line auto-shrink === */
  function fitTextOneLine() {
    // Reset to base size first, then step down until it fits or hits the minimum.
    text.style.fontSize = ''; // revert to CSS (typically 16px from .cart-toast)
    const base = parseFloat(getComputedStyle(text).fontSize) || 16;
    let size = base;
    const min = 11; // don’t go smaller than this

    // Force a reflow to get up-to-date widths
    void text.offsetWidth;

    // Shrink while the content width exceeds the allocated width
    // Guard against infinite loops with a max of (base-min) steps
    let steps = 0, maxSteps = Math.max(0, base - min);
    while (text.scrollWidth > text.clientWidth && size > min && steps <= maxSteps) {
      size -= 1;
      text.style.fontSize = size + 'px';
      steps++;
      // Reflow each iteration for updated measures
      void text.offsetWidth;
    }
  }

  function clearTimer() { if (timer) { clearTimeout(timer); timer = null; } }

  function hide() {
    if (!el.classList.contains('is-visible')) return;
    el.classList.remove('is-visible');
    el.classList.add('is-leaving');
    el.addEventListener('animationend', () => {
      el.hidden = true;
      el.classList.remove('is-leaving','is-replacing');
      // Reset font for the next time
      text.style.fontSize = '';
    }, { once: true });
  }

  function enter() {
    el.classList.remove('is-replacing','is-leaving');
    // Reflow to restart animation
    void el.offsetWidth;

    // Ensure it fits on a single line (will only shrink when truly necessary)
    fitTextOneLine();

    el.classList.add('is-visible');
    clearTimer();
    timer = setTimeout(hide, 5000);
  }

  function show(message = 'Product added to cart') {
    text.textContent = message;
    el.hidden = false;

    if (el.classList.contains('is-visible')) {
      // Replace current toast with a quick shrink, then re-enter
      clearTimer();
      el.classList.add('is-replacing');
      el.addEventListener('animationend', () => enter(), { once: true });
      return;
    }
    enter();
  }

  btnClose.addEventListener('click', () => { clearTimer(); hide(); });

  // Refit on orientation/resize while visible (iOS address-bar changes etc.)
  const onResize = () => {
    if (el.classList.contains('is-visible')) {
      fitTextOneLine();
    }
  };
  window.addEventListener('resize', onResize, { passive: true });
  window.addEventListener('orientationchange', onResize, { passive: true });

  // Public API
  window.CartToast = { show, hide };

  // Wire up to your existing events and new unified event
  document.addEventListener('sadwich:cart-added', (e) => {
    show(e?.detail?.message || 'Product added to cart');
  });
  document.addEventListener('cart-notification:show', () => show('Product added to cart'));
  document.addEventListener('cart-drawer:open', () => show('Product added to cart'));
})();
